import React from 'react';
import { Box, CheckmarkFilledIcon, Typography, ThemeProvider, } from '@kareo/design-system';
import getDesignSystemTheme from 'shared-assets/lib/utils/getDesignSystemTheme';
export default function ThankYou() {
    var _a;
    var theme = getDesignSystemTheme();
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(Box, null,
            React.createElement(Typography, { variant: "h3", style: { color: (_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.success.main } },
                React.createElement(CheckmarkFilledIcon, { fontSize: "small" }),
                React.createElement("span", null, "Payment Processed Successfully")))));
}
